import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getBrain } from "../lib/api";

// Authoritative Island Brain finding pushed onto an individual tile.
const BrainFinding = ({ tile }) => {
  const { data } = useQuery({ queryKey: ["brain"], queryFn: getBrain, refetchInterval: 60000 });
  const f = data?.tile_findings?.[tile];
  if (!f) return null;
  return (
    <div className={`brain-finding bf-${f.severity}`} data-testid={`brain-finding-${tile}`}>
      <span className="bf-tag"><i className="fa-solid fa-hand-holding-heart" /> Island Pulse</span>
      <span className="bf-text">{f.text}</span>
    </div>
  );
};

export default BrainFinding;
